import { getPrimaryTracker } from 'usage-tracker-container';
import { Screens } from '../types/PublicNavItem';
import { Metrics } from './metrics';
export const TRACKING_SOURCES = {
  MERCH_CARD: 'merch-card',
  CREDITS_EXPLAINER: 'credits-explainer',
  BANNER: 'banner',
  CONTENT_FOOTER: 'content-footer',
  CONTENT_MIDDLE: 'content-middle',
  FAQ: 'faq',
  INTEGRATIONS: 'integrations-section',
  PAYMENTS_PROCESSORS_SECTION: 'payments-processors-section',
  PRICING_PAGES: 'pricing-pages',
  AEO_STANDALONE_PROMO_CARD: 'aeo-standalone-promo-card',
  CREATE_A_BUNDLE: 'create-a-bundle',
  AGENT_PACKS: 'agent-packs',
  CREDIT_ESTIMATOR: 'credit-estimator',
  ANCHOR_CTA_SECTION: 'anchor-cta-section',
  PUBLIC: 'public',
  PLAN_QUIZ_MODAL: 'plan-quiz-modal',
  HSOC_FEATURE_TABLE: 'hsoc-feature-table',
  HSOC_MERCH_CARDS_SECTION: 'hsoc-merch-cards-section'
};
function track(eventName, properties) {
  getPrimaryTracker().track('Pricing Pages', eventName, properties);
}
export function trackPageView(properties) {
  track('Pageview', properties);
}
export const HSOC_V2_SCREEN = Screens.HSOC_V2;
export function trackHsocV2PageView() {
  track('Pageview', {
    screen: HSOC_V2_SCREEN
  });
}
export function trackTermSelectorInteraction(properties) {
  track('Term Selector Interaction', properties);
}
export function trackBannerInteraction(properties) {
  track('Banner Interaction', properties);
}
export function trackFaqInteraction(properties) {
  track('Faq Interaction', properties);
}
export function trackClickedLink(properties) {
  track('Link Click', properties);
}
export function trackSectionViewed(properties) {
  track('Section Viewed', properties);
}
export function trackImageInteraction(properties) {
  track('Multimedia Interaction', Object.assign({}, properties, {
    type: 'image'
  }));
}

/* HSOC feature-table interactions (category open/close, mobile tier select,
 * search). Fires the same 'Feature Table Interaction' event as the in-app
 * feature table so the two surfaces report under one event name. */
export function trackFeatureTableInteraction(properties) {
  track('Feature Table Interaction', properties);
}

/* Feature-table impressions (toggle scrolled into view, expanded table viewed).
 * A dedicated 'Section Viewed' helper because these carry a free-form section
 * name + subscreen and the HSOC screen is not a PublicNavItem, neither of which
 * the app-wide trackSectionViewed accepts. */
export function trackFeatureTableSectionViewed(properties) {
  track('Section Viewed', properties);
}
export function trackCommunicationMethodsInteraction(properties) {
  track('Communication Methods Interaction', properties);
}
export function trackTooltipInteraction(properties) {
  track('Tool Tip Interaction', properties);
}
export function trackButtonClick(properties) {
  track('Button Click', properties);
}
export function trackSignupButtonClick(properties) {
  var _properties$screen;
  trackButtonClick(Object.assign({}, properties, {
    action: 'clicked signup button'
  }));
  Metrics === null || Metrics === void 0 || Metrics.counter('signup-clicked', {
    source: properties.trackingSource,
    screen: (_properties$screen = properties.screen) !== null && _properties$screen !== void 0 ? _properties$screen : '',
    version: 'v2'
  }).increment();
}

/* Same shape as trackSignupButtonClick above, fixed to HSOC_V2_SCREEN — kept
 * separate since callers shouldn't need to pass screen explicitly. */
export function trackHsocSignupButtonClick(properties) {
  trackButtonClick(Object.assign({}, properties, {
    screen: HSOC_V2_SCREEN,
    action: 'clicked signup button'
  }));
  Metrics === null || Metrics === void 0 || Metrics.counter('signup-clicked', {
    source: properties.trackingSource,
    screen: HSOC_V2_SCREEN,
    version: 'v2'
  }).increment();
}
export function trackPageViewWithLastKnownEventProperties(properties) {
  track('Pageview', properties);
}
export function trackAdditionalUnitsPicker(properties) {
  track('Additional Units Picker', properties);
}
export function trackModalInteraction(properties) {
  track('Modal Interaction', properties);
}
export function trackPlanBuilderInteraction(properties) {
  track('Plan Builder Interaction', properties);
}
export function trackPurchaseMotionClick(context) {
  var _context$screen, _context$productApiNa, _context$flow;
  const {
    purchaseMotion
  } = context;
  const baseProps = {
    apiName: context.productApiName,
    activeCurrencyCode: context.activeCurrencyCode,
    flow: context.flow,
    ownedProducts: [],
    productNames: context.productNames,
    purchaseMotion: context.purchaseMotion,
    screen: context.screen,
    subscreen: context.subscreen,
    trackingSource: context.trackingSource
  };
  const metricsLabels = {
    source: context.trackingSource,
    screen: (_context$screen = context.screen) !== null && _context$screen !== void 0 ? _context$screen : '',
    apiName: (_context$productApiNa = context.productApiName) !== null && _context$productApiNa !== void 0 ? _context$productApiNa : '',
    version: 'v2'
  };
  switch (purchaseMotion) {
    case 'BUY_TOUCHLESS':
    case 'BUY_ADDITIONAL_SEATS':
    case 'BUY_ADDITIONAL_CONTACTS':
      if (purchaseMotion === 'BUY_TOUCHLESS') {
        Metrics === null || Metrics === void 0 || Metrics.counter('buy-now-clicked', metricsLabels).increment();
      }
      trackButtonClick(Object.assign({}, baseProps, {
        action: 'clicked buy button'
      }));
      break;
    case 'TALK_TO_SALES':
    case 'TALK_TO_SALES_FALLBACK':
      Metrics === null || Metrics === void 0 || Metrics.counter('talk-to-sales-clicked', metricsLabels).increment();
      trackButtonClick(Object.assign({}, baseProps, {
        action: 'click talk to sales',
        flow: (_context$flow = context.flow) !== null && _context$flow !== void 0 ? _context$flow : ''
      }));
      break;
    case 'TRIAL':
      Metrics === null || Metrics === void 0 || Metrics.counter('trial-clicked', metricsLabels).increment();
      trackButtonClick(Object.assign({}, baseProps, {
        action: 'clicked trial button'
      }));
      break;
    default:
  }
}
export function trackHsocPlanQuizEvent(eventName, properties) {
  track(eventName, properties !== null && properties !== void 0 ? properties : {});
}